import { combineReducers } from 'redux';
import authReducer from './authReducer';
import vendorProfileReducer from './vendorProfileReducer';
import jobRequestReducer from './jobRequestReducer';
import { routerReducer } from 'react-router-redux';
import commonReducer from './commonReducer';
import useraccountReducer from './useraccountReducer';
import manageuserReducer from './manageUserReducer';
import driveremergencyReducer from './driveremergencyReducer';



const appReducer = combineReducers({
  authReducer,
  vendorProfileReducer,
  jobRequestReducer,
  commonReducer,
  useraccountReducer,
  manageuserReducer,
  driveremergencyReducer,
  routing: routerReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    const { routing } = state;
    state = { routing };
  }
  return appReducer(state, action);
};
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js